<template>
  <g v-if="doorOpenType"
  :stroke-width="scaleStrokeWidth(doorOpenLine.width)"
  :stroke-dasharray="doorOpenLine.dasharray"
  :stroke="doorOpenLine.color">
    <!-- left -->
    <g v-if="doorOpenType === 1">
      <line :x1="space.x" :y1="space.y + space.h / 2" :x2="space.x + space.w" :y2="space.y" />
      <line :x1="space.x" :y1="space.y + space.h / 2" :x2="space.x + space.w" :y2="space.y + space.h" />
    </g>
    <!-- right -->
    <g v-else-if="doorOpenType === 2">
      <line :x1="space.x" :y1="space.y" :x2="space.x + space.w" :y2="space.y + space.h / 2" />
      <line :x1="space.x" :y1="space.y + space.h" :x2="space.x + space.w" :y2="space.y + space.h / 2" />
    </g>
    <!-- up -->
    <g v-else-if="doorOpenType === 3">
      <line :x1="space.x" :y1="space.y" :x2="space.x + space.w / 2" :y2="space.y + space.h" />
      <line :x1="space.x + space.w / 2" :y1="space.y + space.h" :x2="space.x + space.w" :y2="space.y" />
    </g>
    <!-- down -->
    <g v-else-if="doorOpenType === 4">
      <line :x1="space.x" :y1="space.y + space.h" :x2="space.x + space.w / 2" :y2="space.y" />
      <line :x1="space.x + space.w / 2" :y1="space.y" :x2="space.x + space.w" :y2="space.y + space.h" />
    </g>
    <!-- front -->
    <g v-else-if="doorOpenType === 5">
      <line :x1="space.x" :y1="space.y" :x2="space.x + space.w" :y2="space.y + space.h" />
    </g>
    <!-- fix -->
    <g v-else-if="doorOpenType === 9">
      <line :x1="space.x" :y1="space.y" :x2="space.x + space.w" :y2="space.y + space.h" />
      <line :x1="space.x" :y1="space.y + space.h" :x2="space.x + space.w" :y2="space.y" />
    </g>
  </g>
</template>

<script>
import {SVG_LINE} from '../../../constants/App'
import {VIEW_TYPE} from '../../../constants/Type'
export default {
  name: 'dd-door-open-line',
  props: {
    space: Object,
    attributeValue1: Number,
    viewType: Object,
    sectionPositionZ: Number,
    scaleStrokeWidth: Function
  },
  data () {
    return {
    }
  },
  computed: {
    doorOpenType: function () {
      // 正面のみ対応
      if (!this.attributeValue1 || this.viewType !== VIEW_TYPE.FRONT) return 0
      // 断面位置による制御
      if (this.sectionPositionZ < this.space.z + this.space.d) return 0
      return this.attributeValue1
    },
    doorOpenLine: function () {
      return SVG_LINE.DOOR_OPEN
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/parts/DoorOpenLine.vue